import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../../consts/api";
import { http } from "../../../services/HttpService";

const requestSchema = yup.object({
  patientConsentId: yup.number().required(),
  witnessName: yup.string().required(),
  witnessSignature: yup.string().required(),
});

export function usePatientConsentSignWitnessMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.post(HTTP_ENDPOINTS.patientConsents.signWitness(), {
        patient_consent_id: req.patientConsentId,
        witness_name: req.witnessName,
        witness_signature: req.witnessSignature,
      });
    },
    {
      ...options,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.patientProcedures],
        });
        options?.onSuccess?.();
      },
    },
  );
}
